import CustomButton from "components/CustomButton";
import React from "react";
import { useState } from "react";
import Modal from "react-responsive-modal";
import SurveyService from "services/SurveyService";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";

export default ({ onClose, surveyId, teamId }) => {
  const [loading, setLoading] = useState(false);

  const closeSurvey = () => {
    setLoading(true);
    SurveyService.endSurvey(surveyId, teamId)
      .then(() => {
        setLoading(false);
        onClose(true);
      })
      .catch(() => setLoading(false));
  };
  return (
    <Modal
      center
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "createTaskModal",
      }}
      showCloseIcon={false}
      open
      onClose={() => onClose(false)}
    >
      <div className="modal fade popup-modal withcross create-task-popup">
        <h5 className="text-center createTaskHeading">Are you sure?</h5>
        <CustomButton type="button" buttonClass="btnClose">
          <CloseIcon style={{ width: "20px" }} onClick={() => onClose(false)} />
        </CustomButton>
        <div>
          <h6 className="mt-4 text-center">
            You want to close this survey, as its no longer available for team
            members after that.
          </h6>
          <div className="d-flex justify-content-end mt-4">
            <CustomButton
              buttonClass="btn btn grad_btn full_w"
              disabled={loading}
              onClick={closeSurvey}
            >
              Yes
            </CustomButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};
